import {
  ASSISTANT_PROPOSAL_CONTRACT_VERSION,
  type AiActionProposal,
  type AssistantCapabilities,
  type AssistantConversation,
  type AssistantConversationDetail,
  type AssistantMessage,
  type SendAssistantMessageRequest,
} from '@financial/shared';
import { api } from '../../lib/api';

/**
 * Permite que la API oculte propuestas que una PWA antigua no sabe mostrar.
 * Debe acompañar todas las lecturas y escrituras del módulo, no sólo el envío
 * de mensajes: una conversación puede abrirse después desde otro dispositivo.
 */
const ASSISTANT_REQUEST_CONFIG = {
  headers: { 'X-Assistant-Proposal-Version': String(ASSISTANT_PROPOSAL_CONTRACT_VERSION) },
} as const;

export async function getAssistantCapabilities(): Promise<AssistantCapabilities> {
  return (await api.get<AssistantCapabilities>('/assistant/capabilities', ASSISTANT_REQUEST_CONFIG))
    .data;
}

export async function createAssistantConversation(): Promise<AssistantConversation> {
  return (
    await api.post<AssistantConversation>('/assistant/conversations', {}, ASSISTANT_REQUEST_CONFIG)
  ).data;
}
export async function listAssistantConversations(): Promise<AssistantConversation[]> {
  return (
    await api.get<AssistantConversation[]>('/assistant/conversations', ASSISTANT_REQUEST_CONFIG)
  ).data;
}
export async function getAssistantConversation(id: string): Promise<AssistantConversationDetail> {
  return (
    await api.get<AssistantConversationDetail>(
      `/assistant/conversations/${id}`,
      ASSISTANT_REQUEST_CONFIG,
    )
  ).data;
}
export async function sendAssistantMessage(
  id: string,
  request: SendAssistantMessageRequest,
): Promise<AssistantMessage> {
  return (
    await api.post<AssistantMessage>(
      `/assistant/conversations/${id}/messages`,
      request,
      ASSISTANT_REQUEST_CONFIG,
    )
  ).data;
}

export async function listAssistantProposals(): Promise<AiActionProposal[]> {
  return (await api.get<AiActionProposal[]>('/assistant/proposals', ASSISTANT_REQUEST_CONFIG)).data;
}

export async function getAssistantProposal(id: string): Promise<AiActionProposal> {
  return (await api.get<AiActionProposal>(`/assistant/proposals/${id}`, ASSISTANT_REQUEST_CONFIG))
    .data;
}

export async function confirmAssistantProposal(id: string): Promise<AiActionProposal> {
  return (
    await api.post<AiActionProposal>(
      `/assistant/proposals/${id}/confirm`,
      {},
      ASSISTANT_REQUEST_CONFIG,
    )
  ).data;
}

export async function cancelAssistantProposal(id: string): Promise<AiActionProposal> {
  return (
    await api.post<AiActionProposal>(
      `/assistant/proposals/${id}/cancel`,
      {},
      ASSISTANT_REQUEST_CONFIG,
    )
  ).data;
}
